import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getRoot, $createParagraphNode, ParagraphNode } from 'lexical';

export default function SingleLinePlugin() {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        // Enforce a single paragraph at the root level.
        // Any newly created paragraph will trigger this transform.
        return editor.registerNodeTransform(ParagraphNode, (para: ParagraphNode) => {
            // Avoid doing work on detached nodes
            if (!para.isAttached()) {
                return;
            }

            const root = $getRoot();
            const children = root.getChildren();

            // Collect all paragraph nodes under root
            const paragraphs: ParagraphNode[] = [];
            for (const n of children) {
                if (n instanceof ParagraphNode) {
                    paragraphs.push(n);
                }
            }

            if (paragraphs.length <= 1) {
                return; // Already single-line
            }

            const first = paragraphs[0];

            if (para === first) {
                return;
            }

            const kids = para.getChildren();
            for (const k of kids) {
                first.append(k);
            }

            para.remove();

            if (root.getChildren().length === 0) {
                root.append($createParagraphNode());
            }
        });
    }, [editor]);

    return null;
}
